import Api from 'lib/api';

import { SubmissionError } from 'redux-form';
import { toast } from 'react-toastify';

import { LOGIN_SUCCESS } from 'components/app/login/actions';

const api = Api.getInstance();

const ns = 'app/register/';

export const REGISTER_START = ns + 'REGISTER_START';
export const REGISTER_SUCCESS = ns + 'REGISTER_SUCCESS';
export const REGISTER_FAILURE = ns + 'REGISTER_FAILURE';

export const CHECK_EMAIL_START = ns + 'CHECK_EMAIL_START';
export const CHECK_EMAIL_SUCCESS = ns + 'CHECK_EMAIL_SUCCESS';
export const CHECK_EMAIL_FAILURE = ns + 'CHECK_EMAIL_FAILURE';

export const TERMS_LOADING = ns + 'TERMS_LOADING';
export const TERMS_LOADED = ns + 'TERMS_LOADED';
export const TERMS_ERROR = ns + 'TERMS_ERROR';

export function loadTerms() {
  return async dispatch => {
    dispatch({
      type: TERMS_LOADING
    });

    try {
      const response = await api.get('terms/registration');
      const { data } = response;

      if (data.success) {
        dispatch({
          type: TERMS_LOADED,
          payload: data.terms
        });
      } else {
        toast.error('There was an error loading the page.');
        dispatch({
          type: TERMS_ERROR
        });
      }
    } catch (error) {
      const { response } = error;
      let data = {};

      if (response) {
        data = response.data.data;
      }

      if (data.message) {
        toast.error(data.message);
      }

      dispatch({
        type: TERMS_ERROR,
        payload: data
      });
    }
  };
}

export function register(data, history) {
  return async dispatch => {
    dispatch({
      type: REGISTER_START
    });

    try {
      const response = await api.post('users/register', data);

      localStorage.setItem('user', JSON.stringify(response.data.data.user));
      localStorage.setItem('token', response.data.data.token);

      toast.success(
        'Thanks for registering! Make sure to check your email for a verification link.'
      );

      dispatch({
        type: REGISTER_SUCCESS
      });

      dispatch({
        type: LOGIN_SUCCESS,
        payload: response.data.data.user
      });

      history.push('/account-setup');
    } catch (error) {
      const { response } = error;
      let data = {};

      if (response) {
        data = response.data.data;
      }

      if (data.message) {
        toast.error(data.message);
      }

      dispatch({
        type: REGISTER_FAILURE,
        payload: data
      });

      if (data.errors) {
        let throwErrors = {};

        for (let field in data.errors) {
          throwErrors[field] = Object.values(data.errors[field]).join(', ');
        }

        throw new SubmissionError(throwErrors);
      }
    }
  };
}

export function checkEmail(email) {
  return async dispatch => {
    dispatch({
      type: CHECK_EMAIL_START
    });

    try {
      const response = await api.post('users/check-email', { email });

      dispatch({
        type: CHECK_EMAIL_SUCCESS,
        payload: response.data
      });
    } catch (error) {
      dispatch({
        type: CHECK_EMAIL_FAILURE,
        payload: error
      });
    }
  };
}



// WEBPACK FOOTER //
// ./src/components/app/register/actions.js